import React, { useState, useEffect, useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import ReactPlayer from 'react-player';

interface CarouselItem {
    type: 'image' | 'video';
    src: string;
    videoRef?: React.RefObject<HTMLVideoElement>;
}

const Carousel: React.FC<{ items: CarouselItem[]; onSlideChange?: (index: number) => void }> = ({ items, onSlideChange }) => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [, setIsPlaying] = useState(false);
    const sliderRef = useRef<Slider>(null);
    const currentItemRef = useRef<CarouselItem | null>(null);

    let timeoutId: NodeJS.Timeout;

    const handleSlideChange = (index: number) => {
        setCurrentSlide(index);
        currentItemRef.current = items[index];
        setIsPlaying(false);
        clearTimeout(timeoutId);
        onSlideChange?.(index);
    };

    const handleVideoEnd = () => {
        setIsPlaying(false);
        sliderRef.current?.slickNext();
    };


    useEffect(() => {

        const handleNextSlide = () => {
            const currentItem = items[currentSlide];
            if (currentItem.type === 'image') {
                timeoutId = setTimeout(() => {
                    sliderRef.current?.slickNext();
                }, 5 * 1000); // 5 minutes delay
            }
        };

        const autoplayVideo = () => {
            if (currentItemRef.current?.type === 'video' && currentItemRef.current?.videoRef?.current) {
                currentItemRef.current.videoRef.current.play();
                setIsPlaying(true);
            }
        };

        sliderRef.current?.slickGoTo(0);
        autoplayVideo(); //Autoplay on first slide if video
        handleNextSlide();
        onSlideChange?.(currentSlide);


        return () => clearTimeout(timeoutId);
    }, [items, currentSlide]);

    const settings = {
        dots: false,
        infinite: true,
        speed: 900,
        fade: true,
        cssEase: 'ease-in-out',
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        arrows: false, // Hide next/prev buttons
        afterChange: handleSlideChange,
        beforeChange: (current: number, next: number) => {
            const currentItem = items[current];
            if (
                currentItem.type === 'video' &&
                currentItem.videoRef &&
                currentItem.videoRef.current
            ) {
                currentItem.videoRef.current.pause();
            }
        },
    };

    return (
        <div>
            <Slider ref={sliderRef} {...settings}>
                {items.map((item, index) => (
                    <div key={index}>
                        {item.type === 'image' && (
                            <img
                                src={item.src}
                                alt={`Slide ${index + 1}`}
                                onError={() => sliderRef.current?.slickNext()}
                                style={{ width: "100%", height: "100vh", display: "block", margin: "auto" }}
                            />
                        )}
                        {item.type === 'video' && (
                              <video
                                ref={(el) => (item.videoRef = { current: el })}
                                src={item.src}
                                autoPlay
                                muted
                                playsInline
                                onEnded={handleVideoEnd}
                                onError={() => sliderRef.current?.slickNext()}
                                style={{ width: "100%", height: "100vh", display: "block", margin: "auto" }}
                              />
                        )}
                    </div>
                ))}
            </Slider>
        </div>
    );
};

export default Carousel;

